import React from 'react';
// import PropTypes from 'prop-types';
import { Route, Switch } from 'wouter';

import { useRoutes } from '@folklore/routes';
// import { useLoading } from '../contexts/SiteContext';

import PageLoader from './pages/PageLoader';
import ErrorPage from './pages/Error';

// import * as AppPropTypes from '../lib/PropTypes';

import '../../styles/main.scss';

const propTypes = {
    // statusCode: AppPropTypes.statusCode,
};

const defaultProps = {
    // statusCode: null,
};

const App = () => {
    const routes = useRoutes();
    return (
        <Switch>
            <Route path={routes.home} exact><PageLoader /></Route>
            <Route path={routes['page.project']} exact ><PageLoader /></Route>
            <Route path={routes.page} exact ><PageLoader /></Route>
            <Route path={routes.page_with_parent} exact ><PageLoader /></Route>
            <Route path="*"><ErrorPage /></Route>
        </Switch>
    );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default App;
